import { Link } from "react-router-dom";
import { PageFrame } from "@eaf/ui";
import { Seo } from "../components/seo";

export function NotFoundPage() {
  return (
    <PageFrame narrow>
      <Seo
        title="Page Not Found | Edmund Alan Fain"
        description="The requested page was not found."
      />
      <div className="not-found">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p>The page may have moved or may no longer be available.</p>
        <Link className="btn btn-primary" to="/">
          Return home
        </Link>
      </div>
    </PageFrame>
  );
}
